import { lazy } from 'react'

const Login = lazy(() => import('./Login'))
const ForgotPassword = lazy(() => import('./ForgotPassword'))
const ResetPasswordComplete = lazy(() => import('./ResetPasswordComplete'))
const SignUp = lazy(() => import('./SignUp'))
const NotFound = lazy(() => import('./NotFound'))
const compliteRegistration = lazy(() => import('./CompleteRegistration'))
const authRoutes = [
    {
        path: '/login',
        component: Login,
    },
    {
        path: '/forgot-password',
        component: ForgotPassword,
    },
    {
        path: '/reset-password-complete',
        component: ResetPasswordComplete,
    },
    {
        path: '/signup',
        component: SignUp,
    },
    {
        path: '/session/404',
        component: NotFound,
    },
    {
        path: '/complete_registration',
        component: compliteRegistration,
    },
]

export default authRoutes
